"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _config = require("../config");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var LookUpTextField = function LookUpTextField(_ref) {
  var children = _ref.children,
      id = _ref.id,
      className = _ref.className;
  var text = _config.messagesConfig.EN_US && _config.messagesConfig.EN_US[children];

  if (text) {
    return /*#__PURE__*/_react.default.createElement("span", {
      id: id || "".concat(children, "-text"),
      className: "text ".concat(className)
    }, text);
  }

  return /*#__PURE__*/_react.default.createElement("span", {
    id: id || "".concat(children, "-text"),
    className: "text ".concat(className)
  }, children);
};

LookUpTextField.propTypes = {
  children: _propTypes.default.string.isRequired,
  id: _propTypes.default.string,
  className: _propTypes.default.string
};
var _default = LookUpTextField;
exports.default = _default;